// Protect cart icon and counter from being replaced
(function () {
  let currentItemCount = 0;

  function fetchCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        currentItemCount = cart.item_count;
        ensureCartIconAndCounter();
      })
      .catch(() => {
        // Fallback - try to extract from existing bubble
        const existingBubble = document.querySelector(
          '.cart-count-bubble span[aria-hidden="true"]',
        );
        if (existingBubble) {
          currentItemCount = parseInt(existingBubble.textContent) || 0;
        }
        ensureCartIconAndCounter();
      });
  }

  function ensureCartIconAndCounter() {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (!cartIconBubble) return;

    // Ensure icon exists
    let icon = cartIconBubble.querySelector(".fas.fa-shopping-basket");
    if (!icon) {
      icon = document.createElement("i");
      icon.className = "fas fa-shopping-basket";
      if (cartIconBubble.firstChild) {
        cartIconBubble.insertBefore(icon, cartIconBubble.firstChild);
      } else {
        cartIconBubble.appendChild(icon);
      }
    }

    // Ensure main visually-hidden span exists (not inside cart-count-bubble)
    let mainVisuallyHidden = null;
    const visuallyHiddenSpans =
      cartIconBubble.querySelectorAll(".visually-hidden");
    visuallyHiddenSpans.forEach((span) => {
      if (!span.closest(".cart-count-bubble")) {
        mainVisuallyHidden = span;
      }
    });

    if (!mainVisuallyHidden) {
      mainVisuallyHidden = document.createElement("span");
      mainVisuallyHidden.className = "visually-hidden";
      mainVisuallyHidden.textContent = "Cart";
      cartIconBubble.appendChild(mainVisuallyHidden);
    }

    // Ensure counter bubble exists if there are items
    let counterBubble = cartIconBubble.querySelector(".cart-count-bubble");

    if (currentItemCount > 0) {
      if (!counterBubble) {
        counterBubble = document.createElement("div");
        counterBubble.className = "cart-count-bubble";
        cartIconBubble.appendChild(counterBubble);
      }

      counterBubble.innerHTML = `
        <span aria-hidden="true">${currentItemCount}</span>
        <span class="visually-hidden">${currentItemCount} item${currentItemCount !== 1 ? "s" : ""}</span>
      `;
    } else if (counterBubble) {
      counterBubble.remove();
    }
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fetchCartCount);
  } else {
    fetchCartCount();
  }

  // Watch for changes and restore icon/counter
  let timeoutId;
  const observer = new MutationObserver(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fetchCartCount();
    }, 50);
  });

  // Start observing once the cart icon exists
  function startObserving() {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (cartIconBubble) {
      observer.observe(cartIconBubble, {
        childList: true,
        subtree: false,
      });
    } else {
      setTimeout(startObserving, 100);
    }
  }

  startObserving();

  // Also listen for cart updates
  document.addEventListener("cart:updated", fetchCartCount);

  // Check periodically as a backup
  setInterval(fetchCartCount, 2000);
})();
